// Builds an AG Grid advanced filter model that matches any of the given project entries.
// columnId: the colId in the datasource that holds the project value
// projects: [{ id, project_identifier }]
// valueKey: 'id' | 'identifier' — which project field to compare against the column value
export function buildProjectFilterModel(columnId, projects, valueKey = 'identifier') {
  const values = projects.map(p =>
    valueKey === 'id' ? String(p.id) : String(p.project_identifier)
  );

  if (values.length === 0) return null;

  const makeCondition = (val) => ({
    filterType: 'text',
    type: 'equals',
    filter: val,
    colId: columnId,
  });

  if (values.length === 1) return makeCondition(values[0]);

  return {
    filterType: 'join',
    type: 'OR',
    conditions: values.map(makeCondition),
  };
}
